import { useEffect, useState } from 'react';
const debounce = (fn: Function, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function(this: any, ...args: any[]) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
};

export type WindowDevice = 'mobile' | 'tablet' | 'desktop';

export const useWindowDevice = (): WindowDevice | null => {
    const [windowSize, setWindowSize] = useState<WindowDevice | null>(null);

    function getHeightWidth() {
        if (typeof window !== 'undefined') {
            return {
                width: window.screen.width,
                height: window.screen.height,
            };
        } else return { width: 100, height: 100 };
    }

    function calculateDevice(screenWidth: number): WindowDevice {
        if (screenWidth < 767) return 'mobile';
        if (screenWidth < 992 && screenWidth >= 768) return 'tablet';
        else return 'desktop';
    }

    useEffect(() => {
        // Debounce to avoid the function fire multiple times
        const handleResizeDebounced = debounce(() => {
            const size = getHeightWidth();

            setWindowSize(calculateDevice(size.width));
        });
        handleResizeDebounced();
        window.addEventListener('resize', handleResizeDebounced);
        return () =>
            window.removeEventListener('resize', handleResizeDebounced);
    }, []);

    return windowSize;
};
